module.exports = __webpack_public_path__ + "img/LogoVapza.3a226888.png";